import { Menu } from "./menu.model";
import { RestaurantLocation } from "./restaurantLocation.model";
import { Schedule } from "./schedule.model";

export class Restaurant {
  id: string;
  name: string;
  logo: string;
  locations: RestaurantLocation[];
  menus: Menu[];
  schedules: Schedule[];

  constructor(
    id?: string,
    name?: string,
    logo?: string,
    locations?: RestaurantLocation[],
    menus?: Menu[],
    schedules?: Schedule[]
  ) {
    this.id = id || null;
    this.name = name || null;
    this.logo = logo || null;
    this.locations = locations || [];
    this.menus = menus || [];
    this.schedules = schedules || [];
  }
}
